export default __webpack_public_path__ + "static/char-s-03-cht-637c4e577b42d3b04630787690486edc.png";